import React from 'react';
import { CheckCircle } from 'lucide-react';

const STEPS = ['Compte', 'Profil', 'Diplômes', 'Langues', 'Expériences'];

const StepIndicator = ({ current }) => (
    <div className="flex items-center justify-between mb-6">
        {STEPS.map((label, i) => {
            const done = i < current;
            const active = i === current;
            return (
                <React.Fragment key={i}>
                    <div className="flex flex-col items-center">
                        <div className={`w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold transition-all ${
                            done ? 'bg-green-500 text-white' : active ? 'bg-orange-500 text-white' : 'bg-gray-200 text-gray-500'
                        }`}>
                            {done ? <CheckCircle className="h-4 w-4" /> : i + 1}
                        </div>
                        <span className={`text-xs mt-1 hidden sm:block ${
                            active ? 'text-orange-600 font-semibold' : done ? 'text-green-600' : 'text-gray-400'
                        }`}>{label}</span>
                    </div>
                    {i < STEPS.length - 1 && (
                        <div className={`flex-1 h-0.5 mx-1 transition-all ${i < current ? 'bg-green-400' : 'bg-gray-200'}`} />
                    )}
                </React.Fragment>
            );
        })}
    </div>
);

export default StepIndicator;
